import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {AbstractList} from '../abstract-list';
import {PluginFilter, PluginSettings} from '../abstract-data-api-plugin';

interface ExpertiseFilter extends PluginFilter {
}

interface ExpertiseSettings extends PluginSettings {
}

export {ExpertiseFilter, ExpertiseSettings};

/**
 * Expertise list.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class List extends AbstractList<ExpertiseFilter, ExpertiseSettings> {
  constructor(container: HTMLElement) {
    super(container);
    this.find();
    ComponentRegistry.add('expertise-list', this);
  }

  /**
   * Finds expertises.
   */
  protected find(): void {
    DataApi.instance.expertiseEndpoint.find(this.settings, null)
      .then(response => {
        if (this.isResultEmpty(response)) {
          this.empty();
          return;
        }

        let html = '';
        let i = 0;
        for (const document of response.documents) {
          const template = require('../../handlebars/templates/expertise/item.handlebars');
          html += template({
            document: document,
            isLast: i === response.documents.length - 1,
            iteration: i++
          });
        }
        this.update(html);

        this.emitter.emit('change', this);
      })
      .catch(e => {
        this.error(e);
      });
  }
}
